import React from 'react';
import type { ContractToRegistrationProcessResponse } from '../classes/ContractToRegistrationProcessResponse';
import { VerticalStepper } from '../components/verticalStepper/VerticalStepper';
import { Block } from '@klp/design/Block';
import { Heading } from '@klp/design/index';

type ContractRegistrationProcessProps = {
    process: ContractToRegistrationProcessResponse;
    skalRegistreres: boolean;
};

export default function ContractRegistrationProcess({
    process,
    skalRegistreres,
}: ContractRegistrationProcessProps) {
    const filteredActivities = process.aktiviteter.filter(
        (activity) => activity.isVisible,
    );

    return (
        <Block>
            <Block marginTop="compact">
                <Heading
                    klpHeadingLevel="TWO"
                    klpColor="dark"
                    translation={`checkOffContract.processHeader.${process.type}`}
                />
            </Block>
            <VerticalStepper
                registreringStatus={process.registreringStatus}
                prosessInstansId={process.id}
                skalRegistreres={skalRegistreres}
                activities={filteredActivities}
            />
        </Block>
    );
}
